import { GetPlatformCatalogsParams, PublicationStatus } from "@bvhi/backend-api";
import { Button, BVHISelect, Card, CardContent, CardHeader, Collapse, Grid, TextField } from "@bvhi/ui-base";
import { ClearIcon } from "@bvhi/ui-icons";
import isEqual from "lodash/isEqual";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { BVHIExpandComponent } from "../../../../../../components/bvhi-expand-component";
import { defaultCatalogsFilter } from "./default-catalogs-filter";

interface Props {
  filter: GetPlatformCatalogsParams;
  onChange: ({ key, value }: { key: string; value: string | string[] }) => void;
  onReset: () => void;
}

export const CatalogsFilterCard = ({ filter, onChange, onReset }: Props) => {
  const { t } = useTranslation(["catalogs", "enums", "users"]);
  const [expanded, setExpanded] = useState<boolean>(false);

  const isResetDisabled = useMemo(() => {
    return isEqual(filter, defaultCatalogsFilter);
  }, [filter]);

  return (
    <Card>
      <CardHeader
        restrictContentWidth={false}
        subheader={t("catalogs:catalogs.filter.card.sub.title")}
        title={t("catalogs:catalogs.filter.card.title")}
        action={
          <Button color="secondary" disabled={isResetDisabled} endIcon={<ClearIcon />} onClick={onReset} variant="text">
            {t("catalogs:catalogs.filter.card.button.reset")}
          </Button>
        }
      />
      <CardContent>
        <Grid container pb={2} spacing={2}>
          <Grid xs={12}>
            <TextField
              fullWidth
              label={t("catalogs:catalogs.filter.searchtext.label")}
              placeholder={t("catalogs:catalogs.filter.searchtext.placeholder")}
              value={filter.searchString ?? ""}
              onChange={(e) => {
                onChange({ key: "searchString", value: e.target.value });
              }}
            />
          </Grid>
        </Grid>
        <BVHIExpandComponent expanded={expanded} setExpanded={setExpanded} />
        <Collapse in={expanded} timeout="auto">
          <Grid container spacing={2}>
            <Grid xs={6}>
              <TextField
                fullWidth
                label={t("catalogs:catalogs.form.fields.catalog.name.label")}
                placeholder={t("catalogs:catalogs.form.fields.catalog.name.placeholder")}
                value={filter.platformCatalogName ?? ""}
                onChange={(e) => {
                  onChange({ key: "platformCatalogName", value: e.target.value });
                }}
              />
            </Grid>
            <Grid xs={6}>
              <BVHISelect
                displayEmpty
                fullWidth
                label={t("catalogs:catalogs.datagrid.header.platform.catalog.publicationStatus")}
                multiple
                showReset
                value={filter.platformCatalogStatus ?? []}
                handleChange={(value) => {
                  onChange({ key: "platformCatalogStatus", value: value });
                }}
                handleReset={() => {
                  onChange({ key: "platformCatalogStatus", value: [] });
                }}
                items={[
                  {
                    key: PublicationStatus.DRAFT,
                    value: PublicationStatus.DRAFT,
                    label: t("enums:enums.platform.catalog.status.chip.draft"),
                  },
                  {
                    key: PublicationStatus.PUBLISHED,
                    value: PublicationStatus.PUBLISHED,
                    label: t("enums:enums.platform.catalog.status.chip.published"),
                  },
                ]}
              />
            </Grid>
          </Grid>
        </Collapse>
      </CardContent>
    </Card>
  );
};
